const API =
  process.env.NODE_ENV === "production"
    ? "https://api.gndrv.com"
    : "http://localhost:8080";

function headers(isJSON = true) {
  const token = localStorage.getItem("token");
  const headerDict = {
    Accept: "application/json",
  };
  if (isJSON) {
    headerDict["Content-Type"] = "application/json";
  }
  if (token) {
    headerDict.Authorization = `Bearer ${token}`;
  }

  return headerDict;
}

function parseResponse(response) {
  return response.json().then(json => {
    if (!response.ok) {
      return Promise.reject(json);
    }
    return json;
  });
}

function queryString(params) {
  const query = Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join("&");
  return `${query.length ? "?" : ""}${query}`;
}

export default {
  fetch(url, params = {}) {
    return fetch(`${API}${url}${queryString(params)}`, {
      method: "GET",
      headers: headers(),
    }).then(parseResponse);
  },

  post(url, data) {
    const isJSON = !(data instanceof FormData);
    const body = isJSON ? JSON.stringify(data) : data;

    return fetch(`${API}${url}`, {
      method: "POST",
      headers: headers(isJSON),
      body,
    })
      .then(parseResponse)
      .catch(err => {
        throw err;
      });
  },

  patch(url, data) {
    const body = JSON.stringify(data);

    return fetch(`${API}${url}`, {
      method: "PATCH",
      headers: headers(),
      body,
    }).then(parseResponse);
  },

  delete(url) {
    return fetch(`${API}${url}`, {
      method: "DELETE",
      headers: headers(),
    }).then(parseResponse);
  },
};



// WEBPACK FOOTER //
// ./src/util/api.js